import React from 'react';
import { ButtonField, Tooltip } from '@wk/components-v3-react16';
import { useStopOrchestrations } from '../useStopOrchestrations';

const StopButton = () => {
  const {
    handleStopOrchestrations,
    canStopOrchestrations,
    isPending,
    hideStopButton,
    stopButtonTooltip,
  } = useStopOrchestrations();

  if (hideStopButton) {
    return null;
  }

  return (
    <ButtonField type="primary">
      <button
        id="stopButtonTooltip"
        onClick={handleStopOrchestrations}
        disabled={!canStopOrchestrations || isPending}
      >
        {isPending ? 'Stopping...' : 'Stop Orchestrations'}
      </button>
      <Tooltip
        mode="description"
        targetSelector="#stopButtonTooltip"
        elementId="tooltip1"
      >
        {stopButtonTooltip}
      </Tooltip>
    </ButtonField>
  );
};

export default StopButton;
